import type { Credential } from './Credential'

export type StoredCredentialsResponse = {
  credentials: Credential[]
};